/**
 * Global keyboard shortcut key definitions
 *
 * These keys are reserved for application-wide shortcuts and should not be
 * used by page-specific shortcuts. Use usePageKeyboardShortcuts to ensure
 * no conflicts with these reserved keys.
 */

// Reserved global shortcut keys
export const GLOBAL_SHORTCUT_KEYS = {
  MAIN_NAV_TOGGLE: '1',
  NESTED_SIDEBAR_TOGGLE: '2',
  ASK_YOGI_ANYWHERE_TOGGLE: '3',
  // Two bindings for one shortcut: the engine's matcher requires exact
  // modifier equality, so cmd+K (mac) and ctrl+K (win/linux) are registered
  // separately.
  COMMAND_PALETTE_TOGGLE: 'meta+k',
  COMMAND_PALETTE_TOGGLE_CTRL: 'ctrl+k',
} as const

export type GlobalShortcutKey =
  (typeof GLOBAL_SHORTCUT_KEYS)[keyof typeof GLOBAL_SHORTCUT_KEYS]

export const RESERVED_GLOBAL_KEYS = Object.values(
  GLOBAL_SHORTCUT_KEYS,
) as string[]
